module.exports = __webpack_public_path__ + "media/images/flags/32/Pitcairn-Islands-cdf81a20e5fd67a6fb0a1d03c9bcfabf.png";